const JSON_URL = "https://cdn.shopify.com/s/files/1/0772/3322/5877/files/vehiculos.json?v=1773347109";

async function initVehicleSearch() {

const brandSelect = document.getElementById("vehicle-brand");
const modelSelect = document.getElementById("vehicle-model");
const versionSelect = document.getElementById("vehicle-version");
const yearSelect = document.getElementById("vehicle-year");
const searchBtn = document.getElementById("vehicle-search-btn");

if(!brandSelect) return;

modelSelect.disabled = true;
versionSelect.disabled = true;
yearSelect.disabled = true;
searchBtn.disabled = true;

const response = await fetch(JSON_URL);
const vehicles = await response.json();

/* ===== MARCAS ===== */

const brands = [...new Set(vehicles.map(v => v.brand))].sort();

brands.forEach(brand => {

const option = document.createElement("option");
option.value = brand;
option.textContent = brand;

brandSelect.appendChild(option);

});


/* ===== MODELOS ===== */

brandSelect.addEventListener("change", () => {

modelSelect.innerHTML = '<option disabled selected>Elegí modelo</option>';
versionSelect.innerHTML = '<option disabled selected>Elegí versión</option>';
yearSelect.innerHTML = '<option disabled selected>Elegí año</option>';

modelSelect.disabled = false;
versionSelect.disabled = true;
yearSelect.disabled = true;
searchBtn.disabled = true;

const uniqueModels = [...new Set(
  vehicles.filter(v => v.brand === brandSelect.value).map(v => v.model)
)].sort();

uniqueModels.forEach(model => {

const option = document.createElement("option");
option.value = model;
option.textContent = model;

modelSelect.appendChild(option);

});

});


/* ===== VERSIONES ===== */

modelSelect.addEventListener("change", () => {

versionSelect.innerHTML = '<option disabled selected>Elegí versión</option>';
yearSelect.innerHTML = '<option disabled selected>Elegí año</option>';

versionSelect.disabled = false;
yearSelect.disabled = true;
searchBtn.disabled = true;

const uniqueVersions = [...new Set(
  vehicles
    .filter(v => v.brand === brandSelect.value && v.model === modelSelect.value)
    .map(v => v.version)
)].sort();

uniqueVersions.forEach(version => {

const option = document.createElement("option");
option.value = version;
option.textContent = version;

versionSelect.appendChild(option);

});

});


/* ===== AÑOS ===== */

versionSelect.addEventListener("change", () => {

yearSelect.innerHTML = '<option disabled selected>Elegí año</option>';
yearSelect.disabled = false;
searchBtn.disabled = true;

const filtered = vehicles.filter(v =>
v.brand === brandSelect.value &&
v.model === modelSelect.value &&
v.version === versionSelect.value
);

let years = [];

filtered.forEach(v => {

for(let y = parseInt(v.year_start); y <= parseInt(v.year_end); y++){
years.push(y);
}

});

years = [...new Set(years)].sort();

years.forEach(year => {

const option = document.createElement("option");
option.value = year;
option.textContent = year;

yearSelect.appendChild(option);

});

});


yearSelect.addEventListener("change", () => {
searchBtn.disabled = false;
});


/* ===== BÚSQUEDA ===== */

searchBtn.addEventListener("click", () => {

const filtered = vehicles.find(v =>
v.brand === brandSelect.value &&
v.model === modelSelect.value &&
v.version === versionSelect.value &&
parseInt(yearSelect.value) >= parseInt(v.year_start) &&
parseInt(yearSelect.value) <= parseInt(v.year_end)
);

if(!filtered){
alert("No se encontró la medida del vehículo");
return;
}

const tire = filtered.tire_size;

window.location.href =
"/collections/all?filter.p.m.custom.medida=" + tire;

});

}

document.addEventListener("DOMContentLoaded", initVehicleSearch);
document.addEventListener("shopify:section:load", initVehicleSearch);